<h4 class="card-title">{{ "DailyAmountChart.Title" | translate }}</h4>

<bcu-local-spinner [size]="50" [visible]="!items"></bcu-local-spinner>

@if (chart && isAnyValue) {
    <div class="row">
        <div class="col-md-11">
            <canvas id="dailyAmount">{{ chart }}</canvas>
        </div>
    </div>
}

<!-- <div class="card-body" *ngIf="!isAnyValue">
<p class="card-text text-center size-20"> {{'General.NoData' | translate}}</p>
</div> -->
